import React from 'react';
import NewDeal from '../modules/NewDeal/NewDeal';

const NewDealPage = (props) =>{
  return <NewDeal {...props}/>
}

export default NewDealPage;